import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Link, PrevServiceData } from '@fcp/lib-ui';
import { PrevServiceContainerService } from './prev-service-container.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'fcp-prev-service-container',
  template: `
    <fcp-prev-service
      [prevService]="data | async"
      (wasButtonClicked)="wasButtonClicked.emit($event)"
      (wasLinkClicked)="wasLinkClicked.emit($event)"
      (wasClickedScrollToElement)="wasClickedScrollToElement.emit($event)"
    >
    </fcp-prev-service>
  `
})
export class PrevServiceContainerComponent implements OnInit {
  @Input() private id: string;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasLinkClicked: EventEmitter<Link> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public data: Observable<PrevServiceData>;

  constructor(
    private preServiceContainerService: PrevServiceContainerService
  ) {}

  ngOnInit() {
    this.data = this.preServiceContainerService.getServicos(this.id);
  }
}
